import { Record, Union } from "./.fable/fable-library.3.1.5/Types.js";
import { list_type, option_type, record_type, string_type, class_type, union_type } from "./.fable/fable-library.3.1.5/Reflection.js";
import { FSharpResult$2 } from "./.fable/fable-library.3.1.5/Choice.js";
import { SimpleJson_tryParse } from "./.fable/Fable.SimpleJson.3.18.1/SimpleJson.fs.js";
import { Convert_serialize, Convert_fromJson } from "./.fable/Fable.SimpleJson.3.18.1/Json.Converter.fs.js";
import { createTypeInfo } from "./.fable/Fable.SimpleJson.3.18.1/TypeInfo.Converter.fs.js";
import { newGuid } from "./.fable/fable-library.3.1.5/Guid.js";
import { addHours, addMonths, addDays, utcNow } from "./.fable/fable-library.3.1.5/Date.js";
import { sortBy, ofSeq, cons, singleton, append, filter, map, ofArray } from "./.fable/fable-library.3.1.5/List.js";
import { Cmd_none } from "./.fable/Fable.Elmish.3.1.0/cmd.fs.js";
import { Interop_reactApi } from "./.fable/Feliz.1.37.0/Interop.fs.js";
import { createElement } from "react";
import { join } from "./.fable/fable-library.3.1.5/String.js";
import { compareArrays, equals, createObj } from "./.fable/fable-library.3.1.5/Util.js";
import { Helpers_combineClasses } from "./.fable/Feliz.Bulma.2.11.0/ElementBuilders.fs.js";
import { PropHelpers_createOnKey } from "./.fable/Feliz.1.37.0/Properties.fs.js";
import { key_enter } from "./.fable/Feliz.1.37.0/Key.fs.js";
import { op_PlusPlus } from "./.fable/Feliz.Bulma.2.11.0/Operators.fs.js";
import { map as map_1, empty, singleton as singleton_1, append as append_1, delay } from "./.fable/fable-library.3.1.5/Seq.js";
import { useFeliz_React__React_useElmish_Static_645B1FB7 } from "./.fable/Feliz.UseElmish.1.5.1/UseElmish.fs.js";

class Filter extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["All", "Completed", "NotCompleted"];
    }
}

function Filter$reflection() {
    return union_type("Todo.Filter", [], Filter, () => [[], [], []]);
}

class TodoBeingEdited extends Record {
    constructor(Id, Description) {
        super();
        this.Id = Id;
        this.Description = Description;
    }
}

function TodoBeingEdited$reflection() {
    return record_type("Todo.TodoBeingEdited", [], TodoBeingEdited, () => [["Id", class_type("System.Guid")], ["Description", string_type]]);
}

class Todo extends Record {
    constructor(Id, Description, CompletedOn, CreatedOn, TodoBeingEdited) {
        super();
        this.Id = Id;
        this.Description = Description;
        this.CompletedOn = CompletedOn;
        this.CreatedOn = CreatedOn;
        this.TodoBeingEdited = TodoBeingEdited;
    }
}

function Todo$reflection() {
    return record_type("Todo.Todo", [], Todo, () => [["Id", class_type("System.Guid")], ["Description", string_type], ["CompletedOn", option_type(class_type("System.DateTime"))], ["CreatedOn", class_type("System.DateTime")], ["TodoBeingEdited", option_type(TodoBeingEdited$reflection())]]);
}

class State extends Record {
    constructor(TodoList, NewTodo, Filter) {
        super();
        this.TodoList = TodoList;
        this.NewTodo = NewTodo;
        this.Filter = Filter;
    }
}

function State$reflection() {
    return record_type("Todo.State", [], State, () => [["TodoList", list_type(Todo$reflection())], ["NewTodo", string_type], ["Filter", Filter$reflection()]]);
}

class Msg extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["SetNewTodo", "AddNewTodo", "ToggleCompleted", "DeleteTodo", "CancelEdit", "ApplyEdit", "StartEditingTodo", "SetEditedDescription", "SetFilter"];
    }
}

function Msg$reflection() {
    return union_type("Todo.Msg", [], Msg, () => [[["Item", string_type]], [], [["Item", class_type("System.Guid")]], [["Item", class_type("System.Guid")]], [["Item", class_type("System.Guid")]], [["Item", class_type("System.Guid")]], [["Item", class_type("System.Guid")]], [["Item1", class_type("System.Guid")], ["Item2", string_type]], [["Item", Filter$reflection()]]]);
}

function init() {
    let matchValue, copyOfStruct, copyOfStruct_1, copyOfStruct_2;
    let storedState;
    const arg00_1 = localStorage.getItem("state");
    try {
        storedState = (new FSharpResult$2(0, (matchValue = SimpleJson_tryParse(arg00_1), (matchValue != null) ? Convert_fromJson(matchValue, createTypeInfo(State$reflection())) : (() => {
            throw (new Error("Couldn\u0027t parse the input JSON string because it seems to be invalid"));
        })())));
    }
    catch (ex) {
        storedState = (new FSharpResult$2(1, ex.message));
    }
    if (storedState.tag === 1) {
        return [new State(ofArray([new Todo(newGuid(), "Learn F#", (copyOfStruct = utcNow(), addDays(copyOfStruct, -1)), (copyOfStruct_1 = utcNow(), addMonths(copyOfStruct_1, -1)), void 0), new Todo(newGuid(), "Learn Elmish", void 0, (copyOfStruct_2 = utcNow(), addHours(copyOfStruct_2, -3)), void 0)]), "", new Filter(0)), Cmd_none()];
    }
    else {
        const state = storedState.fields[0];
        return [new State(map((todo) => (new Todo(todo.Id, todo.Description, todo.CompletedOn, todo.CreatedOn, void 0)), state.TodoList), state.NewTodo, state.Filter), Cmd_none()];
    }
}

function update(msg, state) {
    let pattern_matching_result;
    if (msg.tag === 0) {
        pattern_matching_result = 0;
    }
    else if (msg.tag === 3) {
        pattern_matching_result = 1;
    }
    else if (msg.tag === 2) {
        pattern_matching_result = 2;
    }
    else if (msg.tag === 1) {
        if (state.NewTodo === "") {
            pattern_matching_result = 3;
        }
        else {
            pattern_matching_result = 4;
        }
    }
    else {
        pattern_matching_result = 4;
    }
    switch (pattern_matching_result) {
        case 0: {
            return [new State(state.TodoList, msg.fields[0], state.Filter), Cmd_none()];
        }
        case 1: {
            const newState = new State(filter((todo) => (todo.Id !== msg.fields[0]), state.TodoList), state.NewTodo, state.Filter);
            localStorage.setItem("state", Convert_serialize(newState, createTypeInfo(State$reflection())));
            return [newState, Cmd_none()];
        }
        case 2: {
            const newState_1 = new State(map((todo_1) => {
                if (todo_1.Id === msg.fields[0]) {
                    return new Todo(todo_1.Id, todo_1.Description, (todo_1.CompletedOn == null) ? utcNow() : (void 0), todo_1.CreatedOn, todo_1.TodoBeingEdited);
                }
                else {
                    return todo_1;
                }
            }, state.TodoList), state.NewTodo, state.Filter);
            localStorage.setItem("state", Convert_serialize(newState_1, createTypeInfo(State$reflection())));
            return [newState_1, Cmd_none()];
        }
        case 3: {
            return [state, Cmd_none()];
        }
        case 4: {
            switch (msg.tag) {
                case 1: {
                    const newState_2 = new State(append(state.TodoList, singleton(new Todo(newGuid(), state.NewTodo, void 0, utcNow(), void 0))), "", state.Filter);
                    localStorage.setItem("state", Convert_serialize(newState_2, createTypeInfo(State$reflection())));
                    return [newState_2, Cmd_none()];
                }
                case 6: {
                    return [new State(map((todo_2) => {
                        if (todo_2.Id === msg.fields[0]) {
                            return new Todo(todo_2.Id, todo_2.Description, todo_2.CompletedOn, todo_2.CreatedOn, new TodoBeingEdited(todo_2.Id, todo_2.Description));
                        }
                        else {
                            return todo_2;
                        }
                    }, state.TodoList), state.NewTodo, state.Filter), Cmd_none()];
                }
                case 4: {
                    return [new State(map((todo_3) => {
                        if (todo_3.Id === msg.fields[0]) {
                            return new Todo(todo_3.Id, todo_3.Description, todo_3.CompletedOn, todo_3.CreatedOn, void 0);
                        }
                        else {
                            return todo_3;
                        }
                    }, state.TodoList), state.NewTodo, state.Filter), Cmd_none()];
                }
                case 5: {
                    const newState_3 = new State(map((todo_4) => {
                        if (todo_4.Id === msg.fields[0]) {
                            const matchValue = todo_4.TodoBeingEdited;
                            if (matchValue != null) {
                                if (matchValue.Description === "") {
                                    const todoBeingEdited_1 = matchValue;
                                    return todo_4;
                                }
                                else if (matchValue != null) {
                                    return new Todo(todo_4.Id, matchValue.Description, todo_4.CompletedOn, todo_4.CreatedOn, void 0);
                                }
                                else {
                                    throw (new Error("The match cases were incomplete"));
                                }
                            }
                            else {
                                return todo_4;
                            }
                        }
                        else {
                            return todo_4;
                        }
                    }, state.TodoList), state.NewTodo, state.Filter);
                    localStorage.setItem("state", Convert_serialize(newState_3, createTypeInfo(State$reflection())));
                    return [newState_3, Cmd_none()];
                }
                case 7: {
                    return [new State(map((todo_5) => {
                        if (todo_5.Id === msg.fields[0]) {
                            return new Todo(todo_5.Id, todo_5.Description, todo_5.CompletedOn, todo_5.CreatedOn, new TodoBeingEdited(todo_5.Id, msg.fields[1]));
                        }
                        else {
                            return todo_5;
                        }
                    }, state.TodoList), state.NewTodo, state.Filter), Cmd_none()];
                }
                case 8: {
                    const newState_4 = new State(state.TodoList, state.NewTodo, msg.fields[0]);
                    localStorage.setItem("state", Convert_serialize(newState_4, createTypeInfo(State$reflection())));
                    return [newState_4, Cmd_none()];
                }
                default: {
                    throw (new Error("The match cases were incomplete against type of \u0027Msg\u0027 at /Users/pat/Code/Tasks/src/Todo.fs"));
                }
            }
        }
    }
}

const appTitle = (() => {
    let elms_3, elms_1, elms, elms_2, props_4;
    const props_8 = ofArray([["className", "is-spaced"], ["children", Interop_reactApi.Children.toArray([(elms_3 = ofArray([(elms_1 = singleton((elms = singleton(createElement("h1", {
        className: "title is-1",
        children: "To-Do",
    })), createElement("a", {
        className: "navbar-item",
        children: Interop_reactApi.Children.toArray(Array.from(elms)),
    }))), createElement("div", {
        className: "navbar-brand",
        children: Interop_reactApi.Children.toArray(Array.from(elms_1)),
    })), (elms_2 = singleton((props_4 = ofArray([["href", "https://github.com/the-pat/elmish-todo"], ["target", "_blank"], ["children", Interop_reactApi.Children.toArray([createElement("i", {
        className: join(" ", ["is-size-2", "fab", "fa-github"]),
    })])]]), createElement("a", createObj(Helpers_combineClasses("navbar-item", props_4))))), createElement("div", {
        className: "navbar-end",
        children: Interop_reactApi.Children.toArray(Array.from(elms_2)),
    }))]), createElement("div", {
        className: "container",
        children: Interop_reactApi.Children.toArray(Array.from(elms_3)),
    }))])]]);
    return createElement("nav", createObj(Helpers_combineClasses("navbar", props_8)));
})();

function inputField(state, dispatch) {
    let props_2, props, value_6, props_7, props_5;
    const props_9 = ofArray([["className", "has-addons"], ["children", Interop_reactApi.Children.toArray([(props_2 = ofArray([["className", "is-expanded"], ["children", Interop_reactApi.Children.toArray([(props = ofArray([["className", "is-medium"], (value_6 = state.NewTodo, ["ref", (e) => {
        if ((!(e == null)) ? (!equals(e.value, value_6)) : false) {
            e.value = value_6;
        }
    }]), ["onChange", (ev) => {
        dispatch(new Msg(0, ev.target.value));
    }], ["onKeyDown", (ev_1) => {
        PropHelpers_createOnKey(key_enter, (_arg1) => {
            dispatch(new Msg(1));
        }, ev_1);
    }]]), createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", props)))))])]]), createElement("div", createObj(Helpers_combineClasses("control", props_2)))), (props_7 = singleton(["children", Interop_reactApi.Children.toArray([(props_5 = ofArray([op_PlusPlus(["className", "is-primary"], ["className", "is-medium"]), ["onClick", (_arg2) => {
        dispatch(new Msg(1));
    }], ["children", Interop_reactApi.Children.toArray([createElement("i", {
        className: join(" ", ["fas", "fa-plus"]),
    })])]]), createElement("button", createObj(Helpers_combineClasses("button", props_5))))])]), createElement("div", createObj(Helpers_combineClasses("control", props_7))))])]]);
    return createElement("div", createObj(Helpers_combineClasses("field", props_9)));
}

function renderEditForm(uneditedTodoDescription, todoBeingEdited, dispatch) {
    let props_11, props_2, props, value_6, elms, props_5, props_8;
    const elms_1 = singleton((props_11 = ofArray([["className", "is-grouped"], ["children", Interop_reactApi.Children.toArray([(props_2 = ofArray([["className", "is-expanded"], ["children", Interop_reactApi.Children.toArray([(props = ofArray([["className", "is-medium"], (value_6 = todoBeingEdited.Description, ["ref", (e) => {
        if ((!(e == null)) ? (!equals(e.value, value_6)) : false) {
            e.value = value_6;
        }
    }]), ["onChange", (ev) => {
        dispatch(new Msg(7, todoBeingEdited.Id, ev.target.value));
    }]]), createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", props)))))])]]), createElement("div", createObj(Helpers_combineClasses("control", props_2)))), (elms = ofArray([(props_5 = ofSeq(delay(() => append_1(singleton_1(["className", "is-primary"]), delay(() => append_1((todoBeingEdited.Description === uneditedTodoDescription) ? singleton_1(["disabled", true]) : empty(), delay(() => append_1((todoBeingEdited.Description !== uneditedTodoDescription) ? singleton_1(["onClick", (_arg1) => {
        dispatch(new Msg(5, todoBeingEdited.Id));
    }]) : empty(), delay(() => singleton_1(["children", Interop_reactApi.Children.toArray([createElement("i", {
        className: join(" ", ["fas", "fa-save"]),
    })])]))))))))), createElement("button", createObj(Helpers_combineClasses("button", props_5)))), (props_8 = ofArray([["className", "is-warning"], ["onClick", (_arg2) => {
        dispatch(new Msg(4, todoBeingEdited.Id));
    }], ["children", Interop_reactApi.Children.toArray([createElement("i", {
        className: join(" ", ["fas", "fa-arrow-right"]),
    })])]]), createElement("button", createObj(Helpers_combineClasses("button", props_8))))]), createElement("div", {
        className: "buttons",
        children: Interop_reactApi.Children.toArray(Array.from(elms)),
    }))])]]), createElement("div", createObj(Helpers_combineClasses("field", props_11)))));
    return createElement("div", {
        className: "box",
        children: Interop_reactApi.Children.toArray(Array.from(elms_1)),
    });
}

function renderTodo(todo, dispatch) {
    let props_15, elms, props, props_13, elms_1, props_4, props_7, props_10;
    const elms_2 = singleton((props_15 = ofArray([op_PlusPlus(["className", "is-mobile"], ["className", "is-vcentered"]), ["children", Interop_reactApi.Children.toArray([(elms = singleton((props = ofSeq(delay(() => append_1((todo.CompletedOn != null) ? singleton_1(["className", "has-text-grey-light"]) : empty(), delay(() => append_1(singleton_1(["className", "subtitle"]), delay(() => singleton_1(["children", todo.Description]))))))), createElement("p", createObj(Helpers_combineClasses("", props))))), createElement("div", {
        className: "column",
        children: Interop_reactApi.Children.toArray(Array.from(elms)),
    })), (props_13 = ofArray([["className", "is-narrow"], ["children", Interop_reactApi.Children.toArray([(elms_1 = ofArray([(props_4 = ofSeq(delay(() => append_1((todo.CompletedOn != null) ? singleton_1(["className", "is-success"]) : empty(), delay(() => append_1(singleton_1(["onClick", (_arg1) => {
        dispatch(new Msg(2, todo.Id));
    }]), delay(() => singleton_1(["children", Interop_reactApi.Children.toArray([createElement("i", {
        className: join(" ", ["fas", "fa-check"]),
    })])]))))))), createElement("button", createObj(Helpers_combineClasses("button", props_4)))), (props_7 = ofSeq(delay(() => append_1(singleton_1(["className", "is-primary"]), delay(() => append_1((todo.CompletedOn != null) ? singleton_1(["disabled", true]) : empty(), delay(() => append_1((todo.CompletedOn == null) ? singleton_1(["onClick", (_arg2) => {
        dispatch(new Msg(6, todo.Id));
    }]) : empty(), delay(() => singleton_1(["children", Interop_reactApi.Children.toArray([createElement("i", {
        className: join(" ", ["fas", "fa-edit"]),
    })])]))))))))), createElement("button", createObj(Helpers_combineClasses("button", props_7)))), (props_10 = ofArray([["className", "is-danger"], ["onClick", (_arg3) => {
        dispatch(new Msg(3, todo.Id));
    }], ["children", Interop_reactApi.Children.toArray([createElement("i", {
        className: join(" ", ["fas", "fa-trash"]),
    })])]]), createElement("button", createObj(Helpers_combineClasses("button", props_10))))]), createElement("div", {
        className: "buttons",
        children: Interop_reactApi.Children.toArray(Array.from(elms_1)),
    }))])]]), createElement("div", createObj(Helpers_combineClasses("column", props_13))))])]]), createElement("div", createObj(Helpers_combineClasses("columns", props_15)))));
    return createElement("div", {
        className: "box",
        children: Interop_reactApi.Children.toArray(Array.from(elms_2)),
    });
}

function todoList(state, dispatch) {
    const sortedTodoList = sortBy((todo_1) => [todo_1.CompletedOn, todo_1.CreatedOn], filter((todo) => {
        const matchValue = state.Filter;
        switch (matchValue.tag) {
            case 1: {
                return todo.CompletedOn != null;
            }
            case 2: {
                return todo.CompletedOn == null;
            }
            default: {
                return true;
            }
        }
    }, state.TodoList), {
        Compare: (x, y) => compareArrays(x, y),
    });
    return createElement("ul", {
        children: Interop_reactApi.Children.toArray(Array.from(ofSeq(delay(() => map_1((todo_2) => {
            const matchValue_1 = todo_2.TodoBeingEdited;
            let pattern_matching_result, todoBeingEdited_1;
            if (matchValue_1 != null) {
                if (matchValue_1.Id === todo_2.Id) {
                    pattern_matching_result = 0;
                    todoBeingEdited_1 = matchValue_1;
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else {
                pattern_matching_result = 1;
            }
            switch (pattern_matching_result) {
                case 0: {
                    return renderEditForm(todo_2.Description, todoBeingEdited_1, dispatch);
                }
                case 1: {
                    return renderTodo(todo_2, dispatch);
                }
            }
        }, sortedTodoList))))),
    });
}

function renderFilterTabs(state, dispatch) {
    let children, props_1, props_4, props_7;
    const props_10 = ofArray([op_PlusPlus(["className", "is-toggle"], ["className", "is-fullwidth"]), ["children", Interop_reactApi.Children.toArray([(children = ofArray([(props_1 = ofSeq(delay(() => append_1(equals(state.Filter, new Filter(0)) ? singleton_1(["className", "is-active"]) : empty(), delay(() => append_1(singleton_1(["onClick", (_arg1) => {
        dispatch(new Msg(8, new Filter(0)));
    }]), delay(() => singleton_1(["children", Interop_reactApi.Children.toArray([createElement("a", {
        children: "All",
    })])]))))))), createElement("li", createObj(Helpers_combineClasses("", props_1)))), (props_4 = ofSeq(delay(() => append_1(equals(state.Filter, new Filter(1)) ? singleton_1(["className", "is-active"]) : empty(), delay(() => append_1(singleton_1(["onClick", (_arg2) => {
        dispatch(new Msg(8, new Filter(1)));
    }]), delay(() => singleton_1(["children", Interop_reactApi.Children.toArray([createElement("a", {
        children: "Completed",
    })])]))))))), createElement("li", createObj(Helpers_combineClasses("", props_4)))), (props_7 = ofSeq(delay(() => append_1(equals(state.Filter, new Filter(2)) ? singleton_1(["className", "is-active"]) : empty(), delay(() => append_1(singleton_1(["onClick", (_arg3) => {
        dispatch(new Msg(8, new Filter(2)));
    }]), delay(() => singleton_1(["children", Interop_reactApi.Children.toArray([createElement("a", {
        children: "Not Completed",
    })])]))))))), createElement("li", createObj(Helpers_combineClasses("", props_7))))]), createElement("ul", {
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    }))])]]);
    return createElement("div", createObj(Helpers_combineClasses("tabs", props_10)));
}

export function App() {
    let elms_1, elms;
    const patternInput = useFeliz_React__React_useElmish_Static_645B1FB7(init, (msg, state) => update(msg, state), []);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const children_2 = ofArray([appTitle, (elms_1 = singleton((elms = ofArray([inputField(state_1, dispatch), renderFilterTabs(state_1, dispatch), todoList(state_1, dispatch)]), createElement("div", {
        className: "container",
        children: Interop_reactApi.Children.toArray(Array.from(elms)),
    }))), createElement("section", {
        className: "section",
        children: Interop_reactApi.Children.toArray(Array.from(elms_1)),
    }))]);
    return createElement("div", {
        children: Interop_reactApi.Children.toArray(Array.from(children_2)),
    });
}

